import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { getToken, clearToken } from "@pillvery/lib/helpers/utility";
import actions from "./actions";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

export function* setLogin() {
  yield takeEvery(actions.LOGIN_REQUESTED, function* (action) {
    try {
      // Yield same await in generator function
      const user = yield call(actions.setLogin, action.payload); // Yield call to Call async action
      if (user.status === 200) {
        yield localStorage.setItem("pillvery_token", user.token); // yield same await
        yield localStorage.setItem("user", JSON.stringify(user.user_info));
      } else {
        yield put({
          type: actions.LOGIN_FAILED,
          error: user.message,
          loginData: action.payload,
        });
      }

      yield put({ type: actions.LOGIN_SUCCEEDED, user });
    } catch (error) {
      yield put({
        type: actions.LOGIN_FAILED,
        error: error.response.data.message,
        loginData: action.payload,
      });
    }
  });
}
// JSON.parse(localStorage.getItem('user'));

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    yield clearToken();
    history.push("/signin");
    window.location.reload(false);
    localStorage.removeItem("pillvery_token");
    localStorage.removeItem("user");
  });
}

export function* forgotPassword() {
  yield takeEvery(actions.FORGOT_PASSWORD_REQUESTED, function* (action) {
    try {
      const response = yield call(
        actions.sendEmailToForgotPassword,
        action.payload
      );
      yield put({
        type: actions.FORGOT_PASSWORD_SUCCESSDED,
        response,
        email: action.payload.email,
      });
    } catch (error) {
      yield put({
        type: actions.FORGOT_PASSWORD_FAILED,
        error: error.response.data.message,
      });
    }
  });
}

export function* resetCode() {
  yield takeEvery(actions.CHECK_CODE_REQUESTED, function* (action) {
    try {
      const response = yield call(actions.verifyResetCode, action.payload);
      yield put({
        type: actions.CHECK_CODE_SUCCESSDED,
        response,
        email: action.payload.email,
      });
    } catch (error) {
      yield put({
        type: actions.CHECK_CODE_FAILED,
        error: error.response.data.message,
      });
    }
  });
}

export function* resetPassword() {
  yield takeEvery(actions.RESET_PASSWORD_REQUESTED, function* (action) {
    try {
      const response = yield call(actions.resetPasswordRequest, action.payload);
      yield put({ type: actions.RESET_PASSWORD_SUCCESSDED, response });
    } catch (error) {
      yield put({
        type: actions.RESET_PASSWORD_FAILED,
        error: error.response.data.message,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(setLogin),
    fork(logout),
    fork(forgotPassword),
    fork(resetCode),
    fork(resetPassword),
  ]);
}
